"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FaqSectionItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@linaria/react");
var _tracking = require("@site/pattern-library-utils/tracking");
var _breakpoints = require("@site/pattern-library-utils/breakpoints");
var _density = require("@site/pattern-library-utils/density");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
var _ = require(".");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Chevron = /*#__PURE__*/(0, _react2.styled)("span")({
  name: "Chevron",
  class: "pl-c1ih3x87"
});
const FaqItem = /*#__PURE__*/(0, _react2.styled)("details")({
  name: "FaqItem",
  class: "pl-f1ikicru"
});
const Question = /*#__PURE__*/(0, _react2.styled)("summary")({
  name: "Question",
  class: "pl-q1vzm34j"
});
const Answer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "Answer",
  class: "pl-a8fgoeb"
});

/**
 * FaqSectionItem component.
 *
 * @param {Object} props React props
 * @param {string} props.id a unique id
 * @param {string} props._name tracking name for the component
 * @param {string} props.question Question text
 * @param {string|React.ReactNode} props.answer Answer text or span
 * @returns {React.ReactElement} FaqSectionItem component
 * @public
 */
function FaqSectionItem({
  id,
  _name,
  question,
  answer
}) {
  const {
    defaultValue,
    onValueChange
  } = (0, _react.useContext)(_.FaqSectionItemContext);
  const [expanded, setExpanded] = (0, _react.useState)(defaultValue);
  const handleChange = event => {
    if (event.target.tagName !== 'A') {
      event.preventDefault();
    }
    setExpanded(!expanded);
    onValueChange(!expanded);
  };
  const handleKeypress = event => {
    if (event.key === 'Enter' || event.key === ' ') {
      handleChange(event);
    }
  };
  return /*#__PURE__*/_react.default.createElement(FaqItem, (0, _extends2.default)({
    id: `id-${id}`
  }, (0, _tracking.create)(_name), {
    open: expanded,
    onClick: handleChange,
    onKeyPress: handleKeypress,
    tabIndex: 0,
    "data-cy": "faq-item",
    itemScope: true,
    itemProp: "mainEntity",
    itemType: "https://schema.org/Question"
  }), /*#__PURE__*/_react.default.createElement(Question, {
    className: "textHeading",
    tabIndex: -1
  }, /*#__PURE__*/_react.default.createElement("h3", {
    "data-cy": "faq-question",
    itemProp: "name"
  }, question), /*#__PURE__*/_react.default.createElement(Chevron, null, /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    name: "chevron-down"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    key: "content",
    itemScope: true,
    itemProp: "acceptedAnswer",
    itemType: "https://schema.org/Answer"
  }, /*#__PURE__*/_react.default.createElement(Answer, {
    className: "textParagraph",
    "data-cy": "faq-answer",
    itemProp: "text"
  }, answer)));
}
FaqSectionItem.propTypes = {
  id: _propTypes.default.string,
  _name: _propTypes.default.string,
  question: _propTypes.default.string,
  answer: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node])
};